<template>
  <div class="bubble-box">

    <div class="text-with-pad">
      <span class="removed-message invisible-space">{{text}}</span>
    </div>

  </div>
</template>

<script>

  export default {
    props: {
      text: String,
      sent: Boolean,
    }
  }
</script>

<style>
  .bubble-box {
    padding: 4px 16px;
    box-sizing:border-box;
  }

  .removed-message {
    user-select: none;
    font-weight: 300;
    opacity: .85;
  }

</style>
  


